<template>
  <div class="home-page">
    <NavBar />
    <main class="home-main">
      <header class="home-heading">
        <span class="eyebrow">LENGEDU’YA HOŞ GELDİN</span>
        <h1>Öğretmeninle Birebir İngilizce Konuş!</h1>
        <p>Seçtiğin saatte seviyene ve hedefine özel canlı derslerle İngilizceni geliştir.</p>
      </header>

      <section class="feature-card" aria-labelledby="feature-title">
        <div class="feature-copy">
          <span class="eyebrow">SENİN İÇİN YENİLENDİ</span>
          <h2 id="feature-title">Öğrenci ekranlarımız yenilendi.</h2>
          <p>Öğretmeninle canlı derse katılmak ve ders öncesi ön hazırlığını yapmak için aşağıdaki <b>Eğitim Planım</b> tuşuna tıkla.</p>
          <router-link :to="{ name: 'MyEducation' }" class="primary-action">Eğitim Planım <i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
        </div>
        <div class="feature-art"><img src="../assets/images/home/overview/student-refresh.svg" alt="" width="480" height="320" decoding="async"></div>
      </section>

      <section class="packages-intro" aria-labelledby="packages-title">
        <div class="packages-copy">
        <span class="eyebrow">HEDEFİNE UYGUN BİREBİR EĞİTİM</span>
        <h2 id="packages-title">Birebir İngilizce derslerini kendi tempona göre seç.</h2>
        <p>Hedefine ve ihtiyacına uygun eğitim paketlerine göz at.</p>
        <router-link to="/market" class="primary-action">Tüm eğitim paketlerini incele <i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
        </div>
        <img class="packages-art" src="../assets/images/home/overview/time-plan.svg" alt="" width="320" height="320" loading="lazy" decoding="async">
      </section>
      <FeaturedPrograms />
      <section class="discover-section" aria-labelledby="discover-title">
        <h2 id="discover-title">Lengedu’yu keşfet</h2>
        <div class="discover-grid">
          <router-link v-for="feature in features" :key="feature.to" :to="feature.to" class="discover-card">
            <div class="discover-art" aria-hidden="true">
              <img :src="feature.image" alt="" width="480" height="300" loading="lazy" decoding="async">
              <span class="feature-icon"><i :class="`bi bi-${feature.icon}`"></i></span>
            </div>
            <h3>{{ feature.title }}</h3><p>{{ feature.description }}</p>
            <span class="discover-action">{{ feature.action }} <i class="bi bi-arrow-right" aria-hidden="true"></i></span>
          </router-link>
        </div>
      </section>
      <PackageComparison :campaign-code="String($route.query.campaingcode || '')" />
      <footer class="home-help"><router-link to="/faq"><i class="bi bi-question-circle" aria-hidden="true"></i> Birebir İngilizce dersleri hakkında sıkça sorulan sorular</router-link></footer>
    </main>
    <FooterInPage />
  </div>
</template>

<script>
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import FeaturedPrograms from '@/components/Home/FeaturedPrograms.vue';
import PackageComparison from '@/components/Market/PackageComparison.vue';
import practiceImage from '@/assets/images/home/overview/practice.svg';
import conversationImage from '@/assets/images/home/overview/conversation.svg';
import togetherImage from '@/assets/images/home/overview/learn-together.svg';

export default {
  name: 'HomePage',
  components: { NavBar, FooterInPage, FeaturedPrograms, PackageComparison },
  data() {
    return {
      features: [
        { icon: 'stopwatch', title: 'Kısa bir pratik molası', description: 'Egzersizlerle İngilizce pratiğini günlük hayatının bir parçası yap.', action: 'Egzersizleri keşfet', to: '/excercises' },
        { icon: 'chat-dots', title: 'Yeni bir soruyla konuşmaya başla', description: 'Rastgele bir soru seç, kendi cevabını oluştur ve İngilizce konuşma pratiği yap.', action: 'Bir soru oluştur', to: '/excercises/random-question-generator' },
        { icon: 'people', title: 'Birlikte öğrenmek daha güzel', description: 'Arkadaşını davet et, davet programını ve eğitim hediyesinin koşullarını incele.', action: 'Davet programını keşfet', to: '/invite' }
      ].map((feature, index) => ({ ...feature, image: [practiceImage, conversationImage, togetherImage][index] }))
    };
  }
};
</script>

<style scoped>
.home-page { min-height: 100vh; background: #f7f9fb; color: #253545; }
.home-main { max-width: 1100px; margin: auto; padding: 42px 28px 32px; }
.home-heading { width: 100%; margin-bottom: 30px; }
.eyebrow { display: block; color: var(--brand-link); font-size: 11px; font-weight: 700; letter-spacing: 1.3px; margin-bottom: 12px; }
h1 { font-size: clamp(28px, 4vw, 40px); font-weight: 750; letter-spacing: -.8px; margin: 0 0 14px; }
h2 { font-size: clamp(22px, 3vw, 29px); font-weight: 700; line-height: 1.4; }
p { color: #637480; line-height: 1.8; }
.feature-card { display: grid; grid-template-columns: minmax(0, 1fr) 260px; gap: 36px; align-items: center; padding: 36px; background: white; border: 1px solid #e4ecef; border-radius: 20px; }
.feature-copy p { margin: 14px 0 24px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
.feature-art { display: grid; place-items: center; align-self: stretch; padding: 0; overflow: hidden; background: #f7f8f4; border-radius: 16px; }
.feature-art img { display: block; width: 100%; max-width: 280px; height: auto; mix-blend-mode: multiply; }
.primary-action { display: inline-flex; justify-content: center; align-items: center; gap: 20px; background: var(--brand-primary); color: white; border-radius: 10px; padding: 14px 20px; text-decoration: none; font-weight: 600; }
.primary-action { box-shadow: 0 4px 12px #00856a24; }
.primary-action:hover { background: var(--brand-primary-hover); }
.discover-card:nth-child(2) .feature-icon { background: var(--brand-coral-soft); color: var(--brand-coral-text); }
.discover-card:nth-child(3) .feature-icon { background: var(--brand-yellow-soft); color: var(--brand-yellow-text); }
.discover-section { margin-top: 36px; }
.discover-section > h2 { font-size: 20px; margin-bottom: 18px; }
.discover-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; }
.discover-card { display: flex; flex-direction: column; padding: 24px; color: inherit; text-decoration: none; background: white; border: 1px solid #e6edf1; border-radius: 16px; }
.discover-card:hover { border-color: var(--brand-primary); box-shadow: 0 6px 20px #00856a12; }
.discover-art { position: relative; display: grid; place-items: center; height: 180px; margin: -10px -10px 22px; border-radius: 12px; background: #f7f8f4; }


.discover-art img { display: block; width: 100%; max-width: 240px; height: 180px; object-fit: contain; border-radius: 12px; mix-blend-mode: multiply; }
.feature-icon { position: absolute; bottom: -10px; right: 12px; display: grid; place-items: center; width: 36px; height: 36px; border: 3px solid white; border-radius: 11px; color: var(--brand-primary); background: #eff7f3; font-size: 17px; }
.discover-card h3 { font-size: 17px; font-weight: 650; line-height: 1.5; }
.discover-card p { font-size: 14px; }
.discover-action { margin-top: auto; color: var(--brand-link); font-size: 13px; font-weight: 600; }
.packages-intro { display: flex; align-items: center; justify-content: space-between; gap: 32px; margin-top: 48px; padding: 28px 32px; border: 1px solid #e4ece7; border-radius: 20px; background: linear-gradient(115deg, #f0f6f2, #faf8f1); }
.packages-copy { max-width: 740px; min-width: 0; }
.packages-art { flex: 0 0 auto; width: 160px; height: auto; border-radius: 16px; mix-blend-mode: multiply; }
.home-help a { color: var(--brand-link); font-weight: 650; text-decoration: underline; text-underline-offset: 4px; }
.home-help { margin-top: 30px; font-size: 13px; }
a:focus-visible { outline: 3px solid #cf9c30; outline-offset: 4px; }
@media (max-width: 767px) {
  .home-main { padding: 28px 18px; }
  .feature-card { grid-template-columns: 1fr; padding: 24px; gap: 24px; }
  .feature-copy p { display: block; -webkit-line-clamp: unset; overflow: visible; }
  .feature-art { grid-row: 1; }
  .feature-art img { width: 220px; }
  .discover-grid { grid-template-columns: 1fr; }
  .packages-intro { padding: 24px; gap: 20px; flex-direction: column; align-items: flex-start; }
  .packages-art { order: -1; width: 140px; align-self: center; }
  .primary-action { width: 100%; }
}
</style>
